<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Szablony skierowań na badania lekarskie</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">

<div v-if="szablony && szablony.length > 0" class="col-md-4 mt-3">
  <label><strong>Wczytaj szablon:</strong></label>

  <div class="d-flex gap-2">
    <select v-model="selectedSzablonId" class="form-control">
      <option v-for="s in szablony" :key="s.id" :value="s.id">
        {{ s.nazwa }}
      </option>
    </select>

    <button class="btn btn-primary" @click="loadSzablon">
      Wczytaj
    </button>

    <button v-if="this.editingTemplateId" class="btn btn-danger" @click="deleteSzablon">
      Usuń
    </button>
  </div>
</div>
		
<div class="col-md-12 col-lg-12 mt-4">
  <textarea v-model="regula" class="form-control" rows="3" style="white-space: pre-line;"></textarea>
</div>

<div class="col-md-6 col-lg-6 mt-4">
  <h5>Stanowiska pracy:</h5>
  <div v-for="(rowsp, index) in rowssp" :key="index" class="d-flex gap-2 mb-2 align-items-center">
    <input v-model="rowsp.stanowiska" type="text" class="form-control">
    <button @click="addRowSP" class="btn btn-sm btn-success">+</button>
    <button v-if="rowssp.length > 1" @click="removeRowSP(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>

	
<div class="mt-4">
  <h5>I. Czynniki fizyczne:</h5>
  <div class="d-flex gap-2 mb-1">
	<strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
	<strong class="w-100">Wyniki pomiarów</strong>
	<strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
  </div>
  <div v-for="(row, index) in rows" :key="index" class="d-flex gap-2 mb-2 align-items-center">
    <input v-model="row.col1" type="text" class="form-control">
    <input v-model="row.col2" type="text" class="form-control">
 	<input v-model="row.col3" type="text" class="form-control">
    <button @click="addRow" class="btn btn-sm btn-success">+</button>
    <button v-if="rows.length > 1" @click="removeRow(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>
<div class="mt-4">
  <h5>II. Pyły:</h5>
  <div class="d-flex gap-2 mb-1">
	<strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
	<strong class="w-100">Wyniki pomiarów</strong>
	<strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
  </div>
  <div v-for="(row, index) in rows2" :key="index" class="d-flex gap-2 mb-2 align-items-center">
	<input v-model="row.col1" type="text" class="form-control">
    <input v-model="row.col2" type="text" class="form-control">
    <input v-model="row.col3" type="text" class="form-control">
   <button @click="addRow2" class="btn btn-sm btn-success">+</button>
   <button v-if="rows2.length > 1" @click="removeRow2(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>
<div class="mt-4">
  <h5>III. Czynniki chemiczne:</h5>
  <div class="d-flex gap-2 mb-1">
	<strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
	<strong class="w-100">Wyniki pomiarów</strong>
	<strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
  </div>
  <div v-for="(row, index) in rows3" :key="index" class="d-flex gap-2 mb-2 align-items-center">
    <input v-model="row.col1" type="text" class="form-control">
    <input v-model="row.col2" type="text" class="form-control">
    <input v-model="row.col3" type="text" class="form-control">
   <button @click="addRow3" class="btn btn-sm btn-success">+</button>
   <button v-if="rows3.length > 1" @click="removeRow3(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>
<div class="mt-4">
  <h5>IV. Czynniki biologiczne:</h5>
  <div class="d-flex gap-2 mb-1">
	<strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
	<strong class="w-100">Wyniki pomiarów</strong>
	<strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
  </div>
  <div v-for="(row, index) in rows4" :key="index" class="d-flex gap-2 mb-2 align-items-center">
    <input v-model="row.col1" type="text" class="form-control">
    <input v-model="row.col2" type="text" class="form-control">
    <input v-model="row.col3" type="text" class="form-control">
   <button @click="addRow4" class="btn btn-sm btn-success">+</button>
   <button v-if="rows4.length > 1" @click="removeRow4(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>
<div class="mt-4">
  <h5>V. Inne czynniki, w tym niebezpieczne:</h5>
  <div class="d-flex gap-2 mb-1">
	<strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
	<strong class="w-100">Wyniki pomiarów</strong>
	<strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
  </div>
  <div v-for="(row, index) in rows5" :key="index" class="d-flex gap-2 mb-2 align-items-center">
    <input v-model="row.col1" type="text" class="form-control">
    <input v-model="row.col2" type="text" class="form-control">
    <input v-model="row.col3" type="text" class="form-control">
   <button @click="addRow5" class="btn btn-sm btn-success">+</button>
   <button v-if="rows5.length > 1" @click="removeRow5(index)" class="btn btn-sm btn-danger">-</button>
  </div>
</div>

<div class="mt-4">
<button v-if="!editingTemplateId" @click="showSzablonInput = true" class="btn btn-primary mt-3">Zapisz szablon</button>
<button v-else @click="updateSzablon" class="btn btn-success mt-3">Aktualizuj szablon</button>
<button v-if="editingTemplateId" @click="showNewTemplateInput = true" class="btn btn-secondary mt-3 ms-2">Zapisz jako nowy</button>
<button v-if="showNewTemplateInput" @click="showNewTemplateInput = false" class="btn btn-danger mt-3 ms-2">Anuluj</button>
<div v-if="showNewTemplateInput" class="mt-2 d-flex gap-2 align-items-center">
  <input v-model="nazwa_szablonu" class="form-control form-control-sm" style="max-width: 250px;" placeholder="Nazwa nowego szablonu">
  <button @click="saveAsNew" class="btn btn-success btn-sm">Zapisz nowy szablon</button>
</div>
<div v-if="showSzablonInput" class="mt-2 d-flex gap-2 align-items-center">
  <input v-model="nazwa_szablonu" class="form-control form-control-sm" style="max-width: 250px;" placeholder="Nazwa szablonu">
  <button @click="submitSzablon" class="btn btn-success btn-sm">Zapisz</button>
</div>
</div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout},
  props: {
    users: Array,
  },
  data() {
    return {
      hasPermission,
	  editingTemplateId: null,
	  showNewTemplateInput: false,
	  nazwa_szablonu: "",
	  showSzablonInput: false,
	  szablony: [],
	  selectedSzablonId: null,
	  modeSzablon: "new",
	  regula: "Działając na podstawie art. 229 § 4a ustawy z dnia 26 czerwca 1974 r. – Kodeks pracy (Dz. U. z 2022 r. poz. 1510, z późn. zm.), kieruję na badania lekarskie:",
	  rowssp: [{ stanowiska: ""}],
	  rows: [{ col1: "", col2: "", col3: "" }],
	  rows2: [{ col1: "", col2: "", col3: "" }],
	  rows3: [{ col1: "", col2: "", col3: "" }],
	  rows4: [{ col1: "", col2: "", col3: "" }],
	  rows5: [{ col1: "", col2: "", col3: "" }],
    };
  },
mounted() {
  document.addEventListener("click", this.handleClickOutside);
  this.loadSzablony();
  if (!this.data) {
    const today = new Date().toISOString().split('T')[0];
    this.data = today;
  }
},

beforeUnmount() {
  document.removeEventListener("click", this.handleClickOutside);
},

methods: {
  
loadSzablony() {
  axios.get(route('bhp.skierowania.szablony'))
    .then(res => {
      this.szablony = res.data;
    });
},

  handleClickOutside(e) {
    if (!this.$el.contains(e.target)) {
      this.showDropdown = false;
    }
  },
	addRowSP() {
  this.rowssp.push({
    stanowiska: ""
  });
},

	addRow() {
  this.rows.push({
    col1: "",
    col2: "",
    col3: ""
  });
},
addRow2() {
  this.rows2.push({
    col1: "",
    col2: "",
    col3: ""
  });
},
addRow3() {
  this.rows3.push({
    col1: "",
    col2: "",
    col3: ""
  });
},
addRow4() {
  this.rows4.push({
    col1: "",
    col2: "",
    col3: ""
  });
},
addRow5() {
  this.rows5.push({
    col1: "",
    col2: "",
    col3: ""
  });
},

removeRowSP(index) {
  this.rowssp.splice(index, 1);
},

removeRow(index) {
  this.rows.splice(index, 1);
},
removeRow2(index) {
  this.rows2.splice(index, 1);
},
removeRow3(index) {
  this.rows3.splice(index, 1);
},
removeRow4(index) {
  this.rows4.splice(index, 1);
},
removeRow5(index) {
  this.rows5.splice(index, 1);
},
submitSzablon() {
  const payload = {
    nazwa: this.nazwa_szablonu,
    regula: this.regula,
    stanowiska: this.rowssp,
    dane1: this.rows,
    dane2: this.rows2,
    dane3: this.rows3,
    dane4: this.rows4,
    dane5: this.rows5
  };

  axios.post(route('bhp.skierowania.save_szablon'), payload)
    .then(() => {
	  this.showToast('success', 'Zapisano', 'Szablon został zapisany.');
      this.showSzablonInput = false;
      this.nazwa_szablonu = "";
	  this.loadSzablony();
    })
    .catch(err => {
	 this.showToast('error', 'Błąd', 'Nie udało się zapisać szablonu.');
      console.error(err);
    });
},
loadSzablon() {
  if (!this.selectedSzablonId) return;

  axios.get(route('bhp.skierowania.szablon', this.selectedSzablonId))
    .then(res => {
      const s = res.data.szablon;
		this.editingTemplateId = s.id;
		this.showNewTemplateInput = false;
      this.regula = s.regula;
	  this.nazwa_szablonu = s.nazwa || "";
      this.rows = [];
      this.rows2 = [];
      this.rows3 = [];
      this.rows4 = [];
      this.rows5 = [];
      this.rowssp = [];

      s.dane.forEach(d => {
        const row = {
          col1: d.dane_1,
          col2: d.dane_2,
          col3: d.dane_3,
        };

        if (d.data_typ == 1) this.rows.push(row);
        if (d.data_typ == 2) this.rows2.push(row);
        if (d.data_typ == 3) this.rows3.push(row);
        if (d.data_typ == 4) this.rows4.push(row);
        if (d.data_typ == 5) this.rows5.push(row);
        if (d.data_typ == 6) this.rowssp.push({ stanowiska: d.dane_1 });
      });
    });
},
deleteSzablon() {
  if (!this.selectedSzablonId) return;

  Toast.fire({
    toast: false,
    icon: 'warning',
    title: 'Usuwanie szablonu',
    html: 'Czy na pewno chcesz usunąć wybrany szablon?',
    showDenyButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Tak',
    denyButtonText: 'Nie',
    timer: false,
    position: 'center'
  }).then((result) => {
    if (result.isConfirmed) {

      axios.delete(route('bhp.skierowania.delete_szablon', this.selectedSzablonId))
        .then(() => {
          this.selectedSzablonId = null;
          this.editingTemplateId = null;
          this.loadSzablony();

          this.showToast('success', 'Usunięto', 'Szablon został usunięty.');
        })
        .catch(err => {
          console.error(err);
          this.showToast('error', 'Błąd', 'Nie udało się usunąć szablonu.');
        });

    }
  });
},
updateSzablon() {
  if (!this.editingTemplateId) return;
  const payload = this.buildPayload();
  payload.nazwa = this.nazwa_szablonu;
  axios.post(
    route('bhp.skierowania.update_szablon', this.editingTemplateId),
    payload
  )
  .then(() => {
    	  this.showToast('success', 'Zaktualizowano', 'Szablon został zaktualizowany.');
 
    this.loadSzablony();
  })
  .catch(err => {
  this.showToast('error', 'Błąd', 'Nie udało się zaktualizować szablonu.');
    console.error(err);
  });
},
saveAsNew() {
  const payload = this.buildPayload();
  payload.nazwa = this.nazwa_szablonu;
  axios.post(route('bhp.skierowania.save_szablon'), payload)
    .then(() => {
	  this.showToast('success', 'Zapisano', 'Zapisano jako nowy szablon.');
      this.nazwa_szablonu = "";
      this.showNewTemplateInput = false;

      this.editingTemplateId = null;
      this.loadSzablony();
    })
    .catch(err => {
	  this.showToast('error', 'Błąd', 'Nie udało się zapisać jako nowy szablon.');
      console.error(err);
    });
},
buildPayload() {
  return {
    nazwa: this.nazwa_szablonu,
    regula: this.regula,
    stanowiska: this.rowssp,
    dane1: this.rows,
    dane2: this.rows2,
    dane3: this.rows3,
    dane4: this.rows4,
    dane5: this.rows5
  };
},
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
}
};
</script>
